<template>
    <div class="terminalEditHeadDiv">
      <el-row :gutter="5">
        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.sn')}}：</span>
            <span>{{sn}}</span>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.model')}}：</span>
            <span>{{model}}</span>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.deviceId')}}：</span>
            <span>{{deviceId}}</span>
          </div>
        </el-col>

      </el-row>

      <el-row :gutter="5">
        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.activeReportTime')}}：</span>
            <span>{{activeReportTime}}</span>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.pn')}}：</span>
            <span>{{pn}}</span>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="col-label">
            <span class="col-label-span label-font">
              {{$t('message.alertStatus')}}：
            </span>
            <span v-if="alertStatus == 0">{{$t('message.normal')}}</span>
            <span v-else-if="alertStatus == 1">{{$t('message.terminalNoConnect')}}</span>
            <span v-else-if="alertStatus == 2">{{$t('message.terminalLost')}}</span>
            <span v-else-if="alertStatus == 3">{{$t('message.appTaskFailure')}}</span>
            <span v-else-if="alertStatus == 4">{{$t('message.terminalMove')}}</span>
            <span v-else-if="alertStatus == 5">{{$t('message.tamper')}}</span>
            <span v-else-if="alertStatus == 6">{{$t('message.lowMemory')}}</span>
            <span v-else-if="alertStatus == 7">{{$t('message.printerAgeing')}}</span>
            <span v-else-if="alertStatus == 8">{{$t('message.batteryAgeing')}}</span>
            <span v-else-if="alertStatus == 9">{{$t('message.otherError')}}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="5">
        <el-col :span="24">
          <div class="col-label">
            <span class="col-label-span label-font">{{$t('message.timeZone')}}：</span>
            <span>{{timeZoom}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
</template>

<script>
    export default {
        name: "TerminalEditHead",
        props: {
          sn:{
            required: true
          },
          deviceId:{
            required: true
          },
          model:{
            required: true
          },
          activeReportTime:{
            required: true
          },
          pn:{
            required: true
          },
          alertStatus:{
            required: true
          },
          timeZoom:{
            required: true
          }
        },
    }
</script>

<style>
  .col-label {
    margin:10px auto;
  }

  .col-label-span{
    font-family: 'Arial';
    font-size: 15px;
  }

  .terminalEditHeadDiv{
    padding-left: 20px;
    padding-right: 20px;
  }

  .label-font {
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditHead.vue